// Progress bar with chapter tick marks.
//
// The bar already exists (#progress); we add five subtle tick marks at
// the proportional position of each chapter's section top. Recompute on
// resize and on font load (which can shift chapter positions).

const TICK_CHAPTERS: Array<'I' | 'II' | 'III' | 'IV' | 'V'> = ['I', 'II', 'III', 'IV', 'V'];

export function initProgress(): void {
  const bar = document.getElementById('progress');
  if (!bar) return;

  // Build tick container once.
  const ticks = document.createElement('div');
  ticks.className = 'progress-ticks';
  ticks.setAttribute('aria-hidden', 'true');
  const tickEls = new Map<string, HTMLDivElement>();
  for (const c of TICK_CHAPTERS) {
    const t = document.createElement('div');
    t.className = 'progress-tick';
    t.dataset.chapter = c;
    ticks.appendChild(t);
    tickEls.set(c, t);
  }
  bar.parentElement?.insertBefore(ticks, bar);

  // Bar fill scroll-driven.
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const pct = total > 0 ? (window.scrollY / total) * 100 : 0;
      bar!.style.width = pct + '%';
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Tick positions — recompute on resize and after fonts load.
  function repositionTicks() {
    const total = document.documentElement.scrollHeight - window.innerHeight;
    if (total <= 0) return;
    for (const c of TICK_CHAPTERS) {
      const section = document.querySelector<HTMLElement>(`section[data-chapter="${c}"]`);
      if (!section) continue;
      const top = section.offsetTop;
      const pct = (top / total) * 100;
      const el = tickEls.get(c);
      if (el) el.style.left = pct + '%';
    }
  }
  repositionTicks();
  window.addEventListener('resize', repositionTicks, { passive: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(repositionTicks).catch(() => {});
  }
  // Also re-run after a beat in case images / video shift layout.
  setTimeout(repositionTicks, 600);
  setTimeout(repositionTicks, 2000);
}
